import { Link } from "react-router-dom";

export default function Logo({ light = false, className = "" }) {
  return (
    <Link
      to="/"
      aria-label="The Bridge by VA home"
      className={`inline-flex items-center gap-2.5 ${className}`}
    >
      <img
        src="/brand/bridge-byva-original-mark.png"
        alt=""
        aria-hidden="true"
        className="h-11 w-11 object-contain"
      />
      <span className="flex min-w-0 flex-col leading-none">
        <span
          className={`whitespace-nowrap font-display text-[1.15rem] font-extrabold tracking-[-.045em] ${light ? "text-white" : "text-ink"}`}
        >
          Bridge <span className="text-bridge">by VA</span>
        </span>
        <span
          className={`mt-1 whitespace-nowrap text-[8px] font-bold uppercase tracking-[.16em] ${light ? "text-white/65" : "text-ink/55"}`}
        >
          - connecting opportunities -
        </span>
      </span>
    </Link>
  );
}
